/**
 * カスタムボタンの共通処理
 */
$(function () {
    /* ボタン式チェックボックス */
    $(document).on('click', '.check-button input', function() {
        let label = $(this).parent();
        $(label).toggleClass('active', $(this).prop('checked'));
    });
    // ボタン式チェックボックス：単一選択
    $(document).on('click', '.single-check input', function(e) {
        let checked = this;
        let name = $(this).attr('name');
        if ($(checked).prop('checked')){
            $('.single-check input[name="'+name+'"]').each(function(){
                if($(this).val() == $(checked).val()){
                    return true;
                }
                $(this).prop('checked', false);
                let label = $(this).parent();
                $(label).toggleClass('active', false);
            });
        }
    });
    /* ニュースリリースバナー閉じるボタン */
    $(document).on('click', '.news-release-message .close', function() {
        let id = $(this).data('id');
        let datas = [];
        datas.push({'name' : 'id', 'value' : id});
        _ajax.post($(this).data('action'), datas, function(response) {
            $('#news_release_message_'+id).addClass('display-none');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /**
     * モーダル✕ボタン表示（大量データ対策）
     */
    // ×印画像を事前に読み込んでキャッシュ
    let closeImage = new Image();
    closeImage.src = '/assets/img/common/close-white.png';
    closeImage.alt = '閉じる';
    closeImage.onload = function () {
        // モーダル表示後に✕ボタン追加
        $('.js-append-close-btn-modal').on('shown.bs.modal', function () {
            $(this).find('.js-append-close-btn').empty();
            $(this).find('.js-append-close-btn').append(closeImage).show();
        });
    };
    
    // ログイン画面に戻るボタン
    $(document).on('click', '#system-error-reload', function() {
        location.href = location.href.split(/[?#]/)[0];
    });
});
